import { AddShiftComponent } from './add-shift/add-shift.component';
import { EditShiftComponent } from './edit-shift/edit-shift.component';
import { ListShiftComponent } from './list-shift/list-shift.component';

export const ShiftRouter = [
    { path: '', redirectTo: 'list-shift', pathMatch: 'full' },
    { path: 'add-shift', component: AddShiftComponent },
    { path: 'list-shift', component: ListShiftComponent },
    { path: 'edit-shift/:shiftID', component: EditShiftComponent }

];

export const ShiftRoutingBreadcrumbs = [
    { name: 'Edit', path: '/edit-shift' },
    { name: 'Add', path: '/add-shift' },

];